import React, { createContext, useContext, useState } from "react";

const UserContext = createContext();

export function useUser() {
    return useContext(UserContext);
}

export function UserProvider({ children }) {
    const [empId, setEmpId] = useState(
        () => sessionStorage.getItem("empId") || null
    );

    const [menus, setMenus] = useState(() => {
        const stored = sessionStorage.getItem("menus");
        return stored ? JSON.parse(stored) : [];
    });

    const [userInfo, setUserInfo] = useState(() => {
        const stored = sessionStorage.getItem("userInfo");
        return stored ? JSON.parse(stored) : null;
    });

    // Sticky "this tab has signed out" marker. Survives a reload so the login
    // screen stays a terminal page (see the history guard in App.js) instead of
    // letting Back/Forward walk into pages from the ended session.
    const [signedOut, setSignedOut] = useState(
        () => sessionStorage.getItem("signedOut") === "1"
    );

    const loginUser = (token, userEmpId, userMenus, userData) => {
        setEmpId(userEmpId);
        setMenus(userMenus);
        setUserInfo(userData);
        setSignedOut(false);

        sessionStorage.setItem("token", token);
        sessionStorage.setItem("empId", userEmpId);
        sessionStorage.setItem("menus", JSON.stringify(userMenus));
        sessionStorage.setItem("userInfo", JSON.stringify(userData));
        sessionStorage.removeItem("signedOut");
    };

    const logoutUser = () => {
        setEmpId(null);
        setMenus([]);
        setUserInfo(null);
        setSignedOut(true);

        sessionStorage.removeItem("token");
        sessionStorage.removeItem("empId");
        sessionStorage.removeItem("menus");
        sessionStorage.removeItem("userInfo");
        sessionStorage.setItem("signedOut", "1");
    };

    return (
        <UserContext.Provider
            value={{ empId, menus, userInfo, signedOut, loginUser, logoutUser }}
        >
            {children}
        </UserContext.Provider>
    );
}
